import React from 'react';
import { DUMMY_EMPLOYEES } from '@/components/zoho/proto/dummyData';
import ProtoSingleCard from '@/components/zoho/proto/ProtoSingleCard';

export default function ProtoEntityCards({ onSelect, filtered }) {
  var data = filtered || DUMMY_EMPLOYEES;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="proto-entity-grid">
      {data.map(function(emp) {
        return <ProtoSingleCard key={emp.id} emp={emp} onSelect={onSelect} />;
      })}
    </div>
  );
}
